import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-main-epp',
  templateUrl: './main-epp.component.html',
  styleUrls: ['./main-epp.component.scss'],
})
export class MainEppComponent implements OnInit {
  constructor() {}


  ngOnInit() {   
  }
}
